import { useAppStoreReviewDisplayedQuery } from '../data-access/queries/useAppStoreReviewQuery';

export const useAppStoreReviewDisplayed = () => {
	const { isLoading, isSuccess, mutate } = useAppStoreReviewDisplayedQuery();

	return {
		isLoading,
		isSuccess,
		mutate
	};
};
